
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ROIConfigurationQuery"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchAttributes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"categories"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"system"},{"kind":"EnumValue","value":"enrichment"},{"kind":"EnumValue","value":"salesforce"},{"kind":"EnumValue","value":"hubspot"},{"kind":"EnumValue","value":"traits"},{"kind":"EnumValue","value":"pageview_filter"}]}},{"kind":"Argument","name":{"kind":"Name","value":"salesforceSubCategories"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"account"},{"kind":"EnumValue","value":"contact"},{"kind":"EnumValue","value":"lead"}]}},{"kind":"Argument","name":{"kind":"Name","value":"hubspotSubCategories"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"company"},{"kind":"EnumValue","value":"contact"}]}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"Person"}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SearchBuilderAttribute"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"salesPipeline"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SalesPipeline"},"directives":[]}]}}]}}],"loc":{"start":0,"end":497}};
    doc.loc.source = {"body":"#import \"~/components/SearchBuilder/fragments.graphql\"\n#import \"~/pages/audiences/List/bits/SalesPipeline/fragments.graphql\"\n\nquery ROIConfigurationQuery {\n  searchAttributes(\n    categories: [\n      system\n      enrichment\n      salesforce\n      hubspot\n      traits\n      pageview_filter\n    ]\n    salesforceSubCategories: [account, contact, lead]\n    hubspotSubCategories: [company, contact]\n    type: Person\n  ) {\n    ...SearchBuilderAttribute\n  }\n  salesPipeline {\n    ...SalesPipeline\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("~/components/SearchBuilder/fragments.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/pages/audiences/List/bits/SalesPipeline/fragments.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["ROIConfigurationQuery"] = oneQuery(doc, "ROIConfigurationQuery");
        
